export const userSettingsKeys = {
	all: ['userSettings'],
	list: () => ['userSettings', 'list'],
	detail: (id) => ['userSettings', 'detail', id],
};

export const userSettingsMutationKeys = {
	save: ['userSettings', 'save'],
};
